/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CompetitionSeasonCreate,
  CompetitionSeasonRead,
  CompetitionSeasonUpdate,
  HTTPValidationError,
} from '../models/index';
import {
    CompetitionSeasonCreateFromJSON,
    CompetitionSeasonCreateToJSON,
    CompetitionSeasonReadFromJSON,
    CompetitionSeasonReadToJSON,
    CompetitionSeasonUpdateFromJSON,
    CompetitionSeasonUpdateToJSON,
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
} from '../models/index';

export interface CreateCompetitionSeasonRequest {
    competitionSeasonCreate: CompetitionSeasonCreate;
}

export interface DeleteCompetitionSeasonRequest {
    competitionSeasonId: string;
}

export interface GetCompetitionSeasonRequest {
    competitionSeasonId: string;
}

export interface GetCompetitionSeasonsRequest {
    leagueId?: string | null;
}

export interface UpdateCompetitionSeasonRequest {
    competitionSeasonId: string;
    competitionSeasonUpdate: CompetitionSeasonUpdate;
}

/**
 * 
 */
export class CompetitionSeasonsApi extends runtime.BaseAPI {

    /**
     * Create a new competition season.  Competition seasons are platform-wide entities that represent time periods within leagues. Only superadmins can create seasons as they are shared across all organizations.
     * Create Competition Season
     */
    async createCompetitionSeasonRaw(requestParameters: CreateCompetitionSeasonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompetitionSeasonRead>> {
        if (requestParameters['competitionSeasonCreate'] == null) {
            throw new runtime.RequiredError(
                'competitionSeasonCreate',
                'Required parameter "competitionSeasonCreate" was null or undefined when calling createCompetitionSeason().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/competition_seasons/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CompetitionSeasonCreateToJSON(requestParameters['competitionSeasonCreate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CompetitionSeasonReadFromJSON(jsonValue));
    }

    /**
     * Create a new competition season.  Competition seasons are platform-wide entities that represent time periods within leagues. Only superadmins can create seasons as they are shared across all organizations.
     * Create Competition Season
     */
    async createCompetitionSeason(requestParameters: CreateCompetitionSeasonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompetitionSeasonRead> {
        const response = await this.createCompetitionSeasonRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a competition season.  Only superadmins can delete seasons as they are shared across all organizations. This will fail if there are existing competitions associated with this season.
     * Delete Competition Season
     */
    async deleteCompetitionSeasonRaw(requestParameters: DeleteCompetitionSeasonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['competitionSeasonId'] == null) {
            throw new runtime.RequiredError(
                'competitionSeasonId',
                'Required parameter "competitionSeasonId" was null or undefined when calling deleteCompetitionSeason().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/competition_seasons/{competition_season_id}`.replace(`{${"competition_season_id"}}`, encodeURIComponent(String(requestParameters['competitionSeasonId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a competition season.  Only superadmins can delete seasons as they are shared across all organizations. This will fail if there are existing competitions associated with this season.
     * Delete Competition Season
     */
    async deleteCompetitionSeason(requestParameters: DeleteCompetitionSeasonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteCompetitionSeasonRaw(requestParameters, initOverrides);
    }

    /**
     * Get a competition season by ID. Requires authentication.
     * Get Competition Season
     */
    async getCompetitionSeasonRaw(requestParameters: GetCompetitionSeasonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompetitionSeasonRead>> {
        if (requestParameters['competitionSeasonId'] == null) {
            throw new runtime.RequiredError(
                'competitionSeasonId',
                'Required parameter "competitionSeasonId" was null or undefined when calling getCompetitionSeason().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/competition_seasons/{competition_season_id}`.replace(`{${"competition_season_id"}}`, encodeURIComponent(String(requestParameters['competitionSeasonId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CompetitionSeasonReadFromJSON(jsonValue));
    }

    /**
     * Get a competition season by ID. Requires authentication.
     * Get Competition Season
     */
    async getCompetitionSeason(requestParameters: GetCompetitionSeasonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompetitionSeasonRead> {
        const response = await this.getCompetitionSeasonRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all competition seasons, optionally filtered by league_id. Requires authentication.
     * Get Competition Seasons
     */
    async getCompetitionSeasonsRaw(requestParameters: GetCompetitionSeasonsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CompetitionSeasonRead>>> {
        const queryParameters: any = {};

        if (requestParameters['leagueId'] != null) {
            queryParameters['league_id'] = requestParameters['leagueId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/competition_seasons/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CompetitionSeasonReadFromJSON));
    }

    /**
     * Get all competition seasons, optionally filtered by league_id. Requires authentication.
     * Get Competition Seasons
     */
    async getCompetitionSeasons(requestParameters: GetCompetitionSeasonsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CompetitionSeasonRead>> {
        const response = await this.getCompetitionSeasonsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a competition season.  Only superadmins can update seasons as they are shared across all organizations.
     * Update Competition Season
     */
    async updateCompetitionSeasonRaw(requestParameters: UpdateCompetitionSeasonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompetitionSeasonRead>> {
        if (requestParameters['competitionSeasonId'] == null) {
            throw new runtime.RequiredError(
                'competitionSeasonId',
                'Required parameter "competitionSeasonId" was null or undefined when calling updateCompetitionSeason().'
            );
        }

        if (requestParameters['competitionSeasonUpdate'] == null) {
            throw new runtime.RequiredError(
                'competitionSeasonUpdate',
                'Required parameter "competitionSeasonUpdate" was null or undefined when calling updateCompetitionSeason().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/competition_seasons/{competition_season_id}`.replace(`{${"competition_season_id"}}`, encodeURIComponent(String(requestParameters['competitionSeasonId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CompetitionSeasonUpdateToJSON(requestParameters['competitionSeasonUpdate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CompetitionSeasonReadFromJSON(jsonValue));
    }

    /**
     * Update a competition season.  Only superadmins can update seasons as they are shared across all organizations.
     * Update Competition Season
     */
    async updateCompetitionSeason(requestParameters: UpdateCompetitionSeasonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompetitionSeasonRead> {
        const response = await this.updateCompetitionSeasonRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
